<template>
  <v-dialog
    :value="value"
    max-width="640"
    persistent
    scrollable
    :data-testid="testId"
    @input="$emit('input', $event)"
  >
    <v-card class="bulk-upload-modal">
      <v-card-title class="bulk-upload-modal__header white--text">
        <span class="bulk-upload-modal__title">{{ heading }}</span>
        <v-spacer />
        <v-btn
          icon
          dark
          small
          class="bulk-upload-modal__close-btn"
          :data-testid="closeTestId"
          @click="$emit('input', false)"
        >
          <v-icon size="16">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="bulk-upload-modal__body">
        <slot name="body" />
      </v-card-text>

      <v-card-actions class="bulk-upload-modal__footer">
        <slot name="actions" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Centered dialog chrome for BulkUpload.
 * Drawer hosts use the global lb-drawer, which exposes the same body/actions slots.
 */
export default {
  name: 'BulkUploadDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    heading: {
      type: String,
      default: '',
    },
    testId: {
      type: String,
      default: '',
    },
    closeTestId: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import './BulkUploadDialog.scss';
</style>
